import { createServiceFactory } from '@/services/factory'
import { createHttpPracticeGovernanceService } from './practiceGovernance.http'
import { createMockPracticeGovernanceService } from './practiceGovernance.mock'

export const getPracticeGovernanceService = createServiceFactory(
  'assessments',
  createMockPracticeGovernanceService,
  createHttpPracticeGovernanceService
)
